import ShapePalette from "../ShapePalette";

const CirclePropertyPalette = ({ circle }: { circle: GeometricShape }) => {
    return (

        <ShapePalette shapeId={circle.id}>

            {/* <div className='property__element'>
                <ColorInput
                          properyDisplayName={"Line Color"}
                          setValue={setColorValue(circle, "stroke")}
                          getValue={getColorValue(circle, "stroke")}
                    // properyDisplayName="Line Color"
                    // propertyName="stroke"
                    // properyItem={circle}
                />
            </div> */}
            {/* <div className='property__element'>
                <ColorInput
                    properyDisplayName="Fill Color"
                    propertyName="fill"
                    properyItem={circle}
                />
            </div> */}
            <div className='property__element'>
                {/* <NumberInput
                    properyDisplayName="Line weight"
                    propertyName="strokeWidth"
                    properyItem={circle}
                ></NumberInput> */}
            </div>
            <div className='property__element'>
                {/* <NumberInput
                    properyDisplayName="Radius"
                    propertyName="radius"
                    properyItem={circle}
                ></NumberInput> */}
            </div>
            {/* <div className='property__element'>
                <NumberInput
                    properyDisplayName="X"
                    propertyName="x"
                    properyItem={circle}
                ></NumberInput>
            </div>
            <div className='property__element'>
                <NumberInput
                    properyDisplayName="Y"
                    propertyName="y"
                    properyItem={circle}
                ></NumberInput>
            </div> */}
        </ShapePalette>
    )
}

const createPropertyPalette = (circle: GeometricShape) => {
    return <CirclePropertyPalette circle={circle} />
};

export { createPropertyPalette }